import { basicLoadableFetch } from '../../mobx-utils';
import { flow } from 'mobx-state-tree';

export const fetchApiEndpoint = (url) =>
  flow(function* (self) {
    yield basicLoadableFetch(self, url);
  });
